// eslint-disable-next-line import/prefer-default-export
export const INSTALL_APP_IS_CLOSED = 'INSTALL_APP_IS_CLOSED';
